const { Component } = Shopware;

Component.extend('acris-entity-many-to-many-select', 'sw-entity-many-to-many-select', {
    created() {
        this.createdComponent();
    },

    methods: {
        createdComponent() {
            this.$super('createdComponent');

            if (this.context) this.entityCollection.context = this.context;
        },

        sendSearchRequest() {
            this.isLoading = true;

            if (this.criteria) {
                this.searchCriteria.filters = this.criteria.filters;
                this.searchCriteria.associations = this.criteria.associations;
                this.searchCriteria.sortings = this.criteria.sortings;
            }

            return this.searchRepository.search(this.searchCriteria, this.entityCollection.context)
                .then((searchResult) => {
                    if (searchResult.length <= 0) {
                        this.isLoading = false;
                        return searchResult;
                    }

                    if (this.localMode) {
                        this.displaySearch(searchResult);
                        this.isLoading = false;
                        return Promise.resolve(searchResult);
                    }

                    return this.findAssignedEntities(searchResult.getIds(), searchResult);
                });
        },
    }
});
